import React, { type ReactNode } from "react";
import { cn } from "../../../lib/utils/cn";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  error?: string;
}

export default function Checkbox({
  label,
  error,
  className,
  ...props
}: CheckboxProps) {
  return (
    <div className="flex items-center gap-[10px] select-none">
      <input
        type="checkbox"
        className={cn(
          "w-5 h-5 rounded border border-[#e6e6e6] cursor-pointer accent-black shrink-0",
          className,
        )}
        {...props}
      />
      {label && <span className="text-sm text-[#222]">{label}</span>}
      {error && <p className="text-xs text-red-500 ml-7">{error}</p>}
    </div>
  );
}
